import { render, staticRenderFns } from "./withholdGold.vue?vue&type=template&id=144d1e8c&scoped=true"
import script from "./withholdGold.vue?vue&type=script&lang=js"
export * from "./withholdGold.vue?vue&type=script&lang=js"
import style0 from "./withholdGold.vue?vue&type=style&index=0&id=144d1e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144d1e8c",
  null
  
)

export default component.exports